export default __webpack_public_path__ + "static/media/Gauntlets of the Revelations of Tarim.4596cd1b.jpg";